import React from 'react';
import PropTypes from 'prop-types';
import { colors } from './../../assets/theme';

class ItemTitle extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        return (
            <div className="ItemTitle" style={this.props.style}>
                <style jsx>{`
                    .ItemTitle {
                        color:${colors.primary};
                        margin: 0;
                        font-weight: 700;
                        font-size: 20px;
                    }
                `}</style>
                {this.props.content}
            </div>
        )
    }
}

ItemTitle.propTypes = {
    content :PropTypes.string
}

export default ItemTitle;


// WEBPACK FOOTER //
// ./src/components/common/ItemTitle.js